export const BEAM_SUPPORT_EMAIL = 'support@bybeam.co';

export default {
  BEAM_SUPPORT_EMAIL: BEAM_SUPPORT_EMAIL,
};
